import { apiRequest } from '../client';
import type {
  AdminAccountCreateInput,
  AdminAccountCreateResponse,
  AdminAccountResponse,
  AdminAccountUpdateInput,
  AdminAccountUpdateResponse,
} from '../../types/admin-account';

export const adminAccountsApi = {
  getAccount: (accountId: string) => apiRequest<AdminAccountResponse>(`/api/accounts/${encodeURIComponent(accountId)}`),
  updateAccount: (accountId: string, input: AdminAccountUpdateInput) => apiRequest<AdminAccountUpdateResponse>(`/api/accounts/${encodeURIComponent(accountId)}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  }),
  createAccount: (input: AdminAccountCreateInput) => apiRequest<AdminAccountCreateResponse>('/api/accounts', {
    method: 'POST',
    body: JSON.stringify(input),
  }),
};
